import { Clause5 } from '../../pages/clause5page';

export const clause5 = [
  {
    path: 'clause5',
    element: <Clause5 />,
  },
];
